<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="rounded-lg">
          <v-card-title class="am-t2 bold">
            <v-row dense class="space-between align-center">
              <div>Documents de l'association</div>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-toolbar flat dense class="mb-2">
              <v-text-field
                style="max-width: 350px"
                hide-details
                prepend-inner-icon="mdi-magnify"
                dense
                filled
                clearable
                single-line
                label="Recherche par nom  de fichier"
                v-model.trim="filtreNom"
                class="mr-1"
              />
              <a-type-document-select
                style="max-width: 350px"
                prepend-inner-icon="mdi-filter"
                dense
                filled
                clearable
                hide-details
                single-line
                v-model="filtreType"
                label="Recherche par type de document"
                typesDocuments="pieces"
              />
              <v-spacer />
            </v-toolbar>
            <v-row>
              <template v-if="aucunDocument">
                <v-col cols="12">
                  <v-card-text class="text-center text-body-1 ma-5">
                    {{
                      hasFiltre
                        ? "Aucun document ne correspond au filtre."
                        : "Aucun document pour le moment."
                    }}
                  </v-card-text>
                </v-col>
              </template>
              <template v-else>
                <v-col
                  v-for="doc in documentsFiltered"
                  :key="doc.uuid"
                  cols="12"
                  sm="6"
                  lg="4"
                >
                  <a-document-card :value="doc" />
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="showDocumentNumerise">
        <v-card class="rounded-lg">
          <v-card-title class="am-t2 bold">
            <v-row dense class="space-between align-center">
              <div>Documents issus de la numérisation</div>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" lg="4" v-if="documentNumerise">
                <a-document-card :value="documentNumerise" />
              </v-col>
              <v-col cols="12" v-else>
                <v-card-text class="text-center text-body-1 ma-5">
                  <template v-if="documentNumeriseNonTrouve">
                    Aucun document n'a été trouvé.
                  </template>
                  <template v-else>
                    <p>
                        Une action liée à la numérisation est en cours de traitement sur cette association.
                    </p>
                    <template v-if="enCoursAttache">
                      <p>Vous recevrez un mail lorsque la numérisation sera disponible.</p>
                    </template>
                    <template v-else>
                      <p>
                        Vous pouvez également demander une numérisation afin d'être notifié lorsque celle-ci sera disponible.
                      </p>
                    </template>
                  </template>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    numero: {
      type: String,
      required: false,
    },
    versionId: {
      type: Number,
      required: false,
    },
    numerisation: {
      type: Object,
      required: false,
    },
    documents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filtreType: null,
      filtreNom: null,
    };
  },
  computed: {
    aucunDocument() {
      return this.documentsFiltered.length === 0;
    },
    showDocumentNumerise() {
      const etat = this.numerisation?.etat;
      return ["EN_COURS", "EN_COURS_ATTACHE", "DISPONIBLE", "NON_TROUVEE"].includes(etat);
    },
    enCoursAttache() {
      const etat = this.numerisation?.etat;
      return ["EN_COURS_ATTACHE"].includes(etat);
    },
    documentNumeriseNonTrouve() {
      const etat = this.numerisation?.etat;
      return ["NON_TROUVEE"].includes(etat);
    },
    documentNumerise() {
      const doc = this.numerisation?.doc;
      if (!doc) {
        return null;
      }
      return {
        ...doc,
        type: "PIECE_ARCHIVE",
        lien: `/api/association/${this.numero}/document/numerisation/${doc.nom}`,
        actif: true,
      };
    },
    hasFiltre() {
      return !!this.filtreType || !!this.filtreNom;
    },
    documentsFiltered() {
      let documents = [...this.documents].map(d => {
        const out = { ...d };
        if (out.nom && this.numero && this.versionId >= 0) {
          out.lien = `/api/association/${this.numero}/${this.versionId}/document/${out.uuid}/${out.nom}`;
        }
        return out;
      });

      if (this.filtreType) {
        documents = documents.filter(d => d.type === this.filtreType);
      }

      if (this.filtreNom) {
        const filtre = this.filtreNom.toLowerCase();
        documents = documents.filter(d => (d.nom || "").toLowerCase().includes(filtre));
      }

      documents.sort((a, b) => (b.date || "00/00/0000").localeCompare(a.date));
      return documents;
    },
  },
  provide() {
    return {
      validation: {
        fields: [],
      },
    };
  },
};
</script>
